
<form autocomplete="off" novalidate [formGroup]="ExamDivForm">
    <div *ngIf="submitButton">
        <h4 class="main-content-label mb-1"><b>
                Add New Exam Division Record
            </b></h4>
    </div>
    <div *ngIf="deleteButton">
        <h4 class="main-content-label mb-1"><b>
                Delete Exam Division Record
            </b></h4>
    </div>
    <div class="row clearfix">
        <div class="col-sm-4">
            <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>Exam Name</mat-label>
                        <input readonly style="color:black;" matInput formControlName="EmName">
                    </mat-form-field>
            </div>
        </div>
        <div class="col-sm-4" *ngIf="ExamDFormArray['EdStrId'][0]['FormVisible']">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{ExamDFormArray['EdStrId'][0]['FormDisplayName']}}
                            <span *ngIf="ExamDFormArray['EdStrId'][0]['FormRequired']">*</span>
                        </mat-label>
                        <mat-select [disabled]="isShowBranch"  onkeydown="return (event.keyCode!=13);" #select55 class="colorblack" formControlName="EdStrId">
                            <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                [displayMember]="'StrId'" [array]="BranchList"
                                (filteredReturn)="filteredListBranch =$event"></mat-select-filter>
                                <mat-option [value]="0">
                                    None
                                </mat-option>
                            <mat-option [disabled]="isreadonlydel" *ngFor="let item of filteredListBranch" [value]="item.StrId" 
                             (click)="getList(item.StrId)">
                                {{item.StrName}}
                            </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                        *ngIf="ExamDivForm.controls['EdStrId'].touched && ExamDivForm.controls['EdStrId'].errors?.required">
                        This Field Is Mandatory
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div> 
        <div class="col-sm-4" >
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>{{'header.exam-division-data.titleList.Division'
                            | translate}}</mat-label>
                        <mat-select [disabled]="isreadonlydel" required onkeydown="return (event.keyCode!=13);" #select55 class="colorblack" formControlName="EdDiv">
                            <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                [displayMember]="'CdCode'" [array]="codeTypeList"
                                (filteredReturn)="filteredCodeType =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredCodeType" [id]="item.CdCode"
                            (click)="divisonClick(item.CdCode)" [value]="item.CdCode">
                                {{item.CdCode}} - {{item.CdDesc}}
                            </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp" *ngIf="ExamDivForm.controls['EdDiv'].touched && ExamDivForm.controls['EdDiv'].errors?.required">
                            This Field Is Mandatory
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-sm-4" *ngIf="ThPr">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>{{'header.exam-division-data.titleList.ThPr'
                            | translate}}</mat-label>
                        <mat-select [disabled]="isreadonlydel" onkeydown="return (event.keyCode!=13);" #select55 class="colorblack" formControlName="EdEsThPr">
                            <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                [displayMember]="'CdCode'" [array]="codeTypeThPrList"
                                (filteredReturn)="filteredCodeTypeThPr =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredCodeTypeThPr" [value]="item.CdCode">
                                {{item.CdCode}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-sm-2">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{'header.exam-division-data.titleList.Marks'
                            | translate}}
                        </mat-label>
                        <input [readonly]="isreadonlydel" required (change)="valid()" 
                        onkeydown="return (event.keyCode!=13);" class="color" step="0.01" maxlength="5" 
                        matInput formControlName="EdMarksPC" placeholder="Marks">
                        <mat-error class="margin_tp" *ngIf="ExamDivForm.controls['EdMarksPC'].touched && ExamDivForm.controls['EdMarksPC'].errors?.required">
                            This Field Is Mandatory
                        </mat-error>
                        <mat-error class="margin_tp"
                        *ngIf="ExamDivForm.controls['EdMarksPC'].touched && ExamDivForm.controls['EdMarksPC'].errors?.pattern">
                        Please Enter Valid Data
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-sm-2 mt-3 ml-0">
            <div class="form-group">
                <div class="">
                    <p class="psize"> % And Above</p>
                           
                </div>
            </div>
        </div>

        <div class="col-sm-4" *ngIf="Grade">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{'header.exam-division-data.titleList.Grade'
                            | translate}}
                        </mat-label>
                        <input [readonly]="isreadonlydel" min="3" onkeydown="return (event.keyCode!=13);" class="color" matInput formControlName="EdGrade" maxlength="4" placeholder="Min Grade">
                        <mat-error class="margin_tp"
                        *ngIf="ExamDivForm.controls['EdGrade'].touched && ExamDivForm.controls['EdGrade'].errors?.pattern">
                        Please Enter Valid Data
                        </mat-error>
                    </mat-form-field>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-9"></div>
            <div class="col-sm-2 pri-0">
                <button type="button"
                    class="btn size btn-primary btn-icon-text floatright mt-1"
                    (click)="back()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/turn-left.gif"
                            style="margin-right: 5px;">
                        Back
                    </span>
                </button>
            </div>
            <div class="col-sm-1 pri-0" *ngIf="submitButton && ExDivCreate">
                <button type="button"
                    class="btn size btn-primary btn-icon-text floatleft mt-1"
                    (click)="submit()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/save.gif"
                            style="margin-right: 5px;">
                        Save
                    </span>
                </button>
            </div>
            <div class="col-sm-1 pri-0" *ngIf="deleteButton && ExDivDelete">
                <button type="button"
                    class="btn size btn-primary btn-icon-text floatleft mt-1"
                    (click)="openConformationModalBox()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/trash.gif"
                            style="margin-right: 5px;">
                        Delete
                    </span>
                </button>
            </div>
        </div>
    </div>
    <hr *ngIf="ListTable">
    <div *ngIf="ListTable">
        <h4 class="main-content-label mb-1">
            <b>{{'header.exam-division-data.titleList.List'|translate}}</b>
        </h4>
        <!-- <p class="text-muted card-sub-title mb-0">
            Exam Division Data </p> -->
    </div>
    <hr *ngIf="ListTable">
    <div class="table-responsive mt-4" *ngIf="ListTable">
        <table id="datatable" class="table table-bordered text-nowrap">
            <thead>
                <tr class="text-left">
                    <th class="f600">
                        {{'header.exam-division-data.table.Division' | translate}}
                    </th>
                    <th class="f600">
                        {{'header.exam-division-data.table.Marks' | translate}}
                    </th>
                    <th class="f600">
                        {{'header.exam-division-data.table.ThPr' | translate}}
                    </th>
                    <th class="f600">
                        {{'header.exam-division-data.table.Grade' | translate}}
                    </th>
                    <th class="f600 text-center" >
                        {{'header.exam-division-data.table.Action' | translate}}
                    </th>
                </tr>
            </thead>



            <tbody id="table_data">
                <tr *ngFor="let examdiv of examdivList;" class="text-left">

                    <td>{{examdiv.Division}} </td>
                    <td> {{examdiv.EdMarksPC}} </td>
                    <td>{{examdiv.EdEsThPr}} </td>
                    <td>{{examdiv.EdGrade}} </td>
                    <td class="text-center">
                        <a class="btn-floating" title="Delete" (click)="deletee('true',examdiv, examdiv)">
                            <i class="fas fa-trash"></i>

                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</form>